import { render, staticRenderFns } from "./MedicationSelect.vue?vue&type=template&id=6bc6ba10&scoped=true&lang=pug"
import script from "./MedicationSelect.vue?vue&type=script&lang=js"
export * from "./MedicationSelect.vue?vue&type=script&lang=js"
import style0 from "./MedicationSelect.vue?vue&type=style&index=0&id=6bc6ba10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6ba10",
  null
  
)

export default component.exports